export default {
    label: '标签数组',
    labelSwitch: true,
    type: 'tagSource',
    property: '',
    value: {}
}